import {
  HomeOutlined,
  RollbackOutlined,
  SaveOutlined,
  SearchOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { EllipsisOutlined, EditOutlined, StarOutlined, CopyOutlined, DeleteOutlined } from '@ant-design/icons';
import { Link, useNavigate, useParams } from "react-router-dom";
import {Button, Space, Input, MenuProps, Popconfirm, Dropdown, message} from "antd";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import Editor, { TEditorRef } from "@/components/EditorV2";
import { noteServer } from "@/common/notesServer";
import style from "./index.module.less";
import { confirmServer } from '@/common/confirmServer'

import Share from './Component/Share'
import { HamburgerButton } from "@icon-park/react";
import { showLoad,hideLoad } from "@/common/loadServer";
import { atom, useAtom } from "jotai";

export const pdfAtom = atom<boolean>(false);
import { getDoc } from '@model'
import {TNote} from "@/index";
import {generateRandomPageKey, generateUUID2, imgPathPerfix, removeHtmlTags} from "@/utils";
import {nanoid} from "nanoid";
import {useLocation} from "react-use";
import {postMessage, triggerEvent} from "@/common/event";
import {EVENT_COPY_DOC_NOTE, EVENT_NOTE_FULLSCREEN_SAVE} from "@/Const";
import {useTranslation} from "react-i18next";
import {IconDelete, IconMakeCopy, IconNoteSearch, IconRename} from "@/Icon";
import {backgroundColor} from "html2canvas/dist/types/css/property-descriptors/background-color";


/** 笔记操作 */
enum ENoteAction {
  /** 重命名 */
  rename,
  /** 收藏 */
  addToFavorite,
  /** 复制 */
  makeACopy,
  /** 删除 */
  delete,
  /** 恢复 */
  restore,
  /** 永久删除 */
  permancentlyDelete,
  /** 搜索 */
  search
}

let mNoteData:any = null;

const NewNote = forwardRef(function _NewNote(props:{onBackCallback:any,isReadonlyMode:boolean},ref) {
  useImperativeHandle(ref,()=>({
    getNoteData:getNoteData,
    setElementData:setElementData,
    setIsFullScreenDialog:setIsFullScreenDialog
  }));
  // const [name, setName] = useState("");
  const editorRef = useRef<TEditorRef>();
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState<string>();
  const [isFullScreen,setIsFullScreen] = useState(false);
  let localParams = useLocation();
  const [isPdfAtom,setIsPdfAtom] = useAtom(pdfAtom);
  // const setPdfAtom = useAtom(pdfAtom)[1]
  const {t} = useTranslation();


  const items: MenuProps['items'] = [
    {
      label: t("Rename"),
      key: ENoteAction.rename,
      icon: <IconRename/>
    },
    // {
    //   label: data?.isFavirated ? '取消收藏' : '收藏',
    //   key: ENoteAction.addToFavorite,
    //   // icon: <StarOutlined />
    //   icon: <StarOutlined style={{ color: data?.isFavirated ? 'red' : '#333' }} />
    // },
    {
      label: t('Generic copy'),
      key: ENoteAction.makeACopy,
      icon: <IconMakeCopy/>
    }, {
      label: t("Delete"),
      key: ENoteAction.delete,
      icon: <IconDelete/>
    },
    {
      label: t("Search"),
      key: ENoteAction.search,
      icon: <IconNoteSearch/>
    },
  ];
  const handleMenuClick: MenuProps['onClick'] = async (e: any) => {
    const key: ENoteAction = +e.key as ENoteAction
    switch (key) {
      case ENoteAction.restore:
        noteServer.restore(data.id)
        break;
      case ENoteAction.addToFavorite:
        const data3: TNote = await getSaveData() as TNote
        const dataFavirate = noteServer.favitateNote(data3.id)
        if (dataFavirate.isFavirated ===1 ) {
          noteServer.openTip('success', t("Note has Favor"))
        } else {
          noteServer.openTip('success', t("Note has cancel favor"))
        }
        if (params.id) {
          updateData()
        } else {
          navigate('/editNote/' + dataFavirate.id, { replace: true })
        }
        break;
      case ENoteAction.makeACopy:
        const noteSimpleData = editorRef.current?.getNoteData();
        postMessage(EVENT_COPY_DOC_NOTE,noteSimpleData);
        message.info(t("Copyed"))
        // const copyData = noteServer.copy(data2.id, false)
        // navigate('/editNote/' + copyData.id, { replace: true })
        break;
      case ENoteAction.rename:
        editorRef.current?.rename?.()
        break;
      case ENoteAction.delete:
        const deleteRet = await confirmServer.open(t("Confirm delete"), t('Delete note can view trash'), t("Delete"))
        if (deleteRet) {          
          if(params.id){
            noteServer.deleteNote(data.id)
          }else{
            showLoad('')
            const data3 = await editorRef.current?.save?.();
            let newData = noteServer.add({
              ...data3,
            } as TNote);
            noteServer.deleteNote(newData.id)
            hideLoad()
          }
          navigate(-1);
        }
        break;
        case ENoteAction.search:
          window.GSearchOpen?.()
          break;
    }
  };

  async function getSaveData() {
    window.GSearchClose?.()
    showLoad()
    const data = await editorRef.current?.save?.();
    const ret = noteServer[params.id ? "edit" : "add"]({
      ...data,
    } as TNote);
    hideLoad()
    return ret
  }

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  function setIsFullScreenDialog(){
    setIsFullScreen(true);
    editorRef?.current.setIsFullScreen(true);
  }

  /**
   * 获取笔记内容
   */
  async function getNoteData(){
    const noteSimpleData = editorRef.current?.getNoteData();
    const lTime = new Date().getTime();
    if(mNoteData == undefined || mNoteData == null){
      mNoteData = {
        createTime: lTime,
        name: noteSimpleData.name,
        showName:removeHtmlTags(noteSimpleData.name),
        updateTime: lTime,
        id:generateRandomPageKey()
      }
    }
    mNoteData.name = noteSimpleData.name;
    mNoteData.showName = removeHtmlTags(noteSimpleData.name);
    mNoteData.updateTime= lTime;
    mNoteData.doc = noteSimpleData.doc;
    return mNoteData;
  }

  /**
   * 设置内容数据
   * @param element
   */
  function setElementData(element){
    if(element == undefined){
      mNoteData = null;
      setData('');
      return;
    }
    mNoteData = {
      createTime: 0,
      name: element.name,
      searchName: "",
      updateTime: 0,
      id:element.id,
      doc:element.customData.generationData.html
    }
    setData(mNoteData)
  }


  // useEffect(updateData, [params.id]);
  useEffect(()=>{
    if(localParams.state != undefined && localParams.state.usr != null){
      if(localParams.state.usr.hasOwnProperty("isFullScreen")){
        setIsFullScreen(localParams.state.usr.isFullScreen);
      }
      if(localParams.state.usr.hasOwnProperty("newNoteData")){
        mNoteData = localParams.state.usr.newNoteData;
        setData(mNoteData.doc);
      }
    }

  },[])

  /*
  function updateData() {
    if (params.id) {
      const note = noteServer.get(params.id);
      getDoc(params.id).then(r=>{
        setData({
          ...note,
          doc:r?.data
        });

      })
    }
  }
  async function save(toHome = false) {
    window.GSearchClose?.()
    if(toHome && !window.GGetEditorChanged()){
      return navigate('/');
    }
    showLoad('保存中')
    const data = await editorRef.current?.save?.();
    let newData = noteServer[params.id ? "edit" : "add"]({
      ...data,
      // name,
    } as TNote);
    hideLoad()

    if (toHome) {
      return navigate('/');
    }

    noteServer.openTip("success", "保存成功");

    // setTimeout(() => {
    //@ts-ignore
    // navigate(!!toHome ? '/' : -1);
    navigate('/editNote/' + newData.id, { replace: true })
    // }, 300);
  }*/

  /**
   * 保存并更新
   */
  async function saveNote(isSave){
    // const noteData = await getNoteData();
    // triggerEvent(EVENT_NOTE_FULLSCREEN_SAVE,noteData);
    // navigate(-1);
    props.onBackCallback(isSave);
  }

  return (
      //
      <div className={style.NewNote}>
        {
          isFullScreen &&
          <header className={style.header} style={{visibility:isFullScreen?"visible":'collapse',height:'46px',lineHeight:'46px',
            margin:'0px',width:'100%'}}>
            <div size="middle" style={{display:"flex",alignItems:'center',paddingTop:'2px',marginLeft:'1px'}}>
              <Button type={'text'} shape={"circle"} className='padding-bottom-0'>
                <img className='img-medium-small' src={imgPathPerfix()+"back.png"} onClick={() => saveNote(false)} />
              </Button>

              {/*<HomeOutlined style={{display:'none'}} className={style.homeIcon} onClick={() => saveNote()} />*/}
              <Dropdown overlayClassName='default-dropdown-style' menu={menuProps}>
                <div style={{display:"flex",overflow:'hidden', justifyContent:'center',alignItems:'center',marginTop:'0px',visibility:(isFullScreen && !props.isReadonlyMode)?'visible':'hidden'}}>
                  <Button type={"text"} shape={"circle"} className='padding-bottom-0 ml-2'>
                    <img className='img-medium-small' src={imgPathPerfix() + 'menu.png'}/>
                  </Button>
                </div>
              </Dropdown>
            </div>
            <Space size="middle" style={{display:props.isReadonlyMode?'none':'inherit'}}>
              <Button icon={<SaveOutlined />} onClick={() => saveNote(true)}></Button>
              <Share getSaveData={getSaveData} />
            </Space>
          </header>
        }
        <div style={{overflowY:'auto',height:'calc(100% - 1px)',width:'100%'}}>
          <Editor ref={editorRef} data={data} isReadOnlyMode={props.isReadonlyMode}/>
        </div>

        {/*<div style={{backgroundColor: "red"}}>xxx</div>*/}
      </div>


  );
});
export default NewNote;
